export default "__VITE_ASSET__0fc901f0__"